module.exports = __webpack_public_path__ + "media/images/icons/filled/red-envelope-121eef9f018b1ff098e792e26f6b2cf6.svg";